@if (!clientNotFound) {
  <div>
    <!-- Dynamic Notifications Window - conditionally rendered to prevent stacking -->
    @if (showNotificationComponent) {
      <eca-dynamic-notification-window [notificationInputStream]="notificationService.notificationSignal" />
    }
    <div fxLayout="column" fxLayoutAlign="start stetch">
      @if (client) {
        <div class="refresh-container">
          <span class="small-text">Last refreshed at {{lastRefreshed | date : "shortTime"}}
            <a (click)="getIssueClientServiceMapping()" style="color: darkgray; cursor: pointer;">&emsp; <u>Refresh</u></a>
          </span>
        </div>
      }
      @if (clientServices) {
        <div fxLayout="row" fxLayoutAlign="center" id="statusdiv">
          <table mat-table [dataSource]="statusTableDataSource" multiTemplateDataRows>
            <ng-container matColumnDef="serviceAlias">
              <th style ="width: 70%" mat-header-cell *matHeaderCellDef> SERVICE </th>
              <td mat-cell *matCellDef="let element" class="subtitle-2" style="display: block; padding-top: 7px; padding-bottom: 7px">
                <span class="subtitle-2">{{element.serviceAlias}} </span>
                <span class="subtitle-2" style="font-weight: 500"><br> {{element.serviceDescription}}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="serviceStatus">
              <th mat-header-cell *matHeaderCellDef class="cell-right" >STATUS</th>
              <td mat-cell *matCellDef="let element" class="header-cell-right subtitle-2"
                [ngStyle]="{'color': element.serviceStatusColor}"> {{element.serviceStatus}}
                @if (element.issues?.length > 0) {
                  <a class="nav-bar-link"
                  style="cursor: pointer; padding: 5px"
                  (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()">{{expandedElement === element ? 'Collapse' : 'View'}}</a>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="statusTableColumnsWithExpand.length">
                <div class="element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                  @for (issue of element.issues; track issue) {
                    <div style = "margin-top: 10px; margin-bottom: 10px; margin-left: 10px; text-align: center">
                      <b style= "font-size: 16px">{{issue.title}}</b>
                      <br>
                        @for (issueUpdate of issue.outageUpdates; track issueUpdate) {
                          <div style="padding-left: 10px; padding-top: 3px">
                            <p>
                              <b class={{issueUpdate.color}}>{{issueUpdate.status || issue.status}}</b> - {{issueUpdate.comment}}
                              <br>
                                <span class="small-text">Posted on {{issueUpdate.createTime | date: 'short' }}.</span>
                                <mat-divider></mat-divider>
                              </p>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="statusTableColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: statusTableColumns;" class="element-row" id="matrow"
                  [class.expanded-row]="expandedElement === element"
                ></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" id="expandedrow"></tr>
              </table>
            </div>
          }
        </div>
        @if (client) {
          <div id="desctiptiondiv">
            <div class="admin-actions">
              @if (hasUpdatePermission) {
                <a routerLink="/status/update">Administration</a>
              }
              @if (hasUpdatePermission) {
                <button mat-button routerLink="" (click)="logOut()">Logout</button>
              }
            </div>
          </div>
        }
        @if (client) {
          <div id="clientdesctiptiondiv">
            <p class="x-small">{{client.description}}</p>
          </div>
        }
      </div>
    }
    @if (clientNotFound) {
      <div>
        <app-welcome></app-welcome>
      </div>
    }
